import { Pipe, PipeTransform } from '@angular/core';
import { PeriodType } from '../enums/period-type';


@Pipe({
    name: 'periodLabel'
})
export class PeriodLabelPipe implements PipeTransform {

    transform(qty: number, periodUnitId: number): string {
        if (!periodUnitId || periodUnitId === 0) {
            return 'Sin periodo';
        }

        switch (periodUnitId) {
            case PeriodType.Year:
                return qty === 1 ? '1 Año' : `${qty} Años`;
            case PeriodType.Month:
                return qty === 1 ? '1 Mes' : `${qty} Meses`;
            case PeriodType.Week:
                return qty === 1 ? '1 Semana' : `${qty} Semanas`;
            case PeriodType.Day:
                return qty === 1 ? '1 Día' : `${qty} Días`;
            default:
                return `${qty}`;
        }
    }
}